export * from '@wix/headless-faq/react';